import { InputCheckbox, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { FilterCount, FilterSection } from "@flights/search-ui";
import useUserAgent from "../../../../hooks/useUserAgent";
import React, { useRef } from "react";
import useSearchFiltersController from "../useSearchFiltersController";
import flights_apex_web_filter_on_flexible_ticket from "../../../../utils/experiments/apex/flights_apex_web_filter_on_flexible_ticket";
import useIsInViewport from "../../../../hooks/useIsInViewport";
import { useAppliedFilters } from "../../../../hooks/search/useAppliedFilters";
import { useGetAvailableFilters } from "../../SearchResults/components/boundsFilterHooks";
import styles from "./FlexibilityFilter.module.css";
import flights_web_budget_layover_airports_filters from "../../../../utils/experiments/funnel/flights_web_budget_layover_airports_filters";
import useFlightsWebWeekendTopFilter from "../../../../utils/experiments/funnel/flights_web_weekend_top_filter";

const FlexibilityFilter = () => {
  const i18n = useI18n();
  const { isMobile } = useUserAgent();
  const { flexibility } = useSearchFiltersController();
  const visibilityRef = useRef<HTMLDivElement>(null);
  const isInViewport = useIsInViewport(visibilityRef);
  const appliedFilters = useAppliedFilters();
  const { filteredTotalCount } = useGetAvailableFilters();
  const { apexOverlap } = useFlightsWebWeekendTopFilter();

  if (!flexibility.flexibleTicket.count) return null;

  const isFlexibleTicketChecked = flexibility.flexibleTicket.checked;

  if (isInViewport)
    flights_apex_web_filter_on_flexible_ticket.trackStages(
      isMobile,
      isFlexibleTicketChecked,
      appliedFilters.length,
      filteredTotalCount
    );

  const addNewFilters = !!flights_web_budget_layover_airports_filters.trackWithDefaultStage();

  const trackingPlaceholder = (
    <div ref={visibilityRef} className={addNewFilters ? styles.addNewFilters : styles.trackingPlaceholder} />
  );

  if (!flights_apex_web_filter_on_flexible_ticket.trackWithDefaultStage()) return trackingPlaceholder;

  apexOverlap();

  return (
    <>
      {trackingPlaceholder}
      <FilterSection
        attributes={{ "data-testid": "flexible_ticket_filter" }}
        title={{
          text: i18n.trans(t("flights_sr_filters_flexibility")),
          tagName: addNewFilters ? "h3" : "h2",
          attributes: { id: "flexible_ticket_filter" },
          variant: addNewFilters ? "strong_2" : "emphasized_1"
        }}
      >
        <FilterCount count={flexibility.flexibleTicket.count}>
          <InputCheckbox
            checked={isFlexibleTicketChecked}
            onChange={({ checked }) => {
              if (checked) {
                flights_apex_web_filter_on_flexible_ticket.goals.enable_flex();
                flights_apex_web_filter_on_flexible_ticket.goalsWithValue.enable_flex_filter_count(1);
              } else {
                flights_apex_web_filter_on_flexible_ticket.goals.disable_flex();
              }
              flexibility.set(checked, "flexibleTicket");
            }}
            label={
              <>
                <Text>{i18n.trans(t("flights_sr_filters_flex_ticket"))}</Text>
                <Text color="neutral_alt">{i18n.trans(t("flights_sr_filters_flex_ticket_description"))}</Text>
              </>
            }
            name="flexibleTicket"
          />
        </FilterCount>
      </FilterSection>
    </>
  );
};

export default FlexibilityFilter;
